module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tip":"Пожалуйста, уточните причину отказа. Это поможет нам сделать сервис лучше!","send":"Отправить","successMessage":"Спасибо за обратную связь"}}')
  delete Component.options._Ctor
}
